// extracted by mini-css-extract-plugin
export var printerCard = "_ba-1";
export var printerCardConfigured = "_ba-2";
export var printerCardError = "_ba-3";
export var printerCardsContainer = "_ba-0";
export var printerIcon = "_ba-8";
export var printerIconConfigured = "_ba-5";
export var printerIconContainer = "_ba-4";
export var printerIconError = "_ba-6";
export var printerIconUnconfigured = "_ba-7";
export var workstationsTableCard = "_ba-9";